export default __webpack_public_path__ + "static/media/g-2.5826fcbf.jpg";